import { Popover } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import styles from './index.module.scss';

const FULL_SCREEN_ICON = 'https://photostudio-ai-oss.arcsoft.com.cn//photostudio-opshub/FreeCanvas/zoom.svg';

const MIN_ZOOM = 10;
const MAX_ZOOM = 200;
const STEP = 20;

const ZoomToolbar = ({ zoom = 100, onZoomChange, onFitCanvas }) => {

    const handleZoomIn = () => {
        const next = Math.min(zoom + STEP, MAX_ZOOM);
        onZoomChange?.(next);
    };

    const handleZoomOut = () => {
        const next = Math.max(zoom - STEP, MIN_ZOOM);
        onZoomChange?.(next);
    };

    const zoomMenuContent = (
        <div className={styles.zoomMenu}>
            <div className={styles.zoomMenuItem} onClick={handleZoomIn}>
                <span>放大</span><span className={styles.shortcut}>Ctrl +</span>
            </div>
            <div className={styles.zoomMenuItem} onClick={handleZoomOut}>
                <span>缩小</span><span className={styles.shortcut}>Ctrl -</span>
            </div>
            <div className={styles.zoomMenuDivider} />
            <div className={styles.zoomMenuItem} onClick={() => onZoomChange?.(50)}>缩放至50%</div>
            <div className={styles.zoomMenuItem} onClick={() => onZoomChange?.(100)}>缩放至100%</div>
            <div className={styles.zoomMenuItem} onClick={() => onZoomChange?.(200)}>缩放至200%</div>
        </div>
    );

    return (
        <div className={styles.wrapper}>
            <Popover content="展示全部" placement="top" arrow={false}>
                <span className={styles.btn} onClick={onFitCanvas}>
                    <img src={FULL_SCREEN_ICON} alt="展示全部" width={16} height={16} />
                </span>
            </Popover>
            <span className={styles.divider} />
            <span className={styles.btn} onClick={handleZoomOut}>
                <MinusOutlined style={{ fontSize: 14 }} />
            </span>
            <Popover content={zoomMenuContent} placement="top" arrow={false} overlayInnerStyle={{ padding: 4 }} overlayStyle={{ paddingBottom: 8 }}>
                <span className={styles.zoomText}>{zoom}%</span>
            </Popover>
            <span className={styles.btn} onClick={handleZoomIn}>
                <PlusOutlined style={{ fontSize: 14 }} />
            </span>
        </div>
    );
};

export default ZoomToolbar;
